<template>
  <div class="profit_box">
    <div class="profit_box--sections">
      <div class="profit_box--section">
        <h4 class="profit_box--section--heading">{{ label }}</h4>

        <div class="flex flex-centered">
          <div class="profit_box--section--stat">
            <p class="profit_box--section--stat--count">{{ formatCurrency(profit) }}</p>
            <p v-if="projectedProfitPercentage" :class="['profit_box--section--stat--label', changePercentageClass]">{{ changePercentageLabel }}</p>
          </div>
        </div>
      </div>

      <div class="profit_box--divider"/>

      <div class="profit_box--section">
        <h4 class="profit_box--section--heading">ROI</h4>

        <div class="flex flex-centered">
          <div class="profit_box--section--stat">
            <p class="profit_box--section--stat--count">{{ formatPercent(roi) }}</p>
          </div>
        </div>
      </div>

      <div class="profit_box--divider"/>

      <div class="profit_box--section">
        <h4 class="profit_box--section--heading">Dollar for Dollar</h4>

        <div class="flex flex-centered">
          <div class="profit_box--section--stat">
            <p class="profit_box--section--stat--count">{{ formatDigit(dollar) }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utils from "../../../services/utils";

export default {
  name: "StatsCampaignsProfitBox",
  props: {
    label: String,
    profit: {
      type: Number,
      required: true
    },
    projectedProfitPercentage: {
      type: Number,
      default: 0
    },
    actualProfitPercentage: {
      type: Number,
      default: 0,
    },
    roi: {
      type: Number,
      required: true
    },
    dollar: {
      type: Number,
      required: true
    },
  },
  computed: {
    changePercentage() {
      if (this.projectedProfitPercentage <= 0) return null
      return ((this.actualProfitPercentage - this.projectedProfitPercentage) / this.projectedProfitPercentage) * 100
    },
    changePercentageClass() {
      if (!this.changePercentage) return null
      return (this.changePercentage > 0) ? 'positive' : 'negative'
    },
    changePercentageLabel() {
      if (!this.changePercentage) return null

      const percentage = this.changePercentage.toFixed(2)

      if (this.changePercentage > 0) return `+${percentage} over projected`
      return `${percentage} under projected`
    }
  },
  methods: {
    formatDigit(value) {
      if (!value) return '--'
      return utils.formatDigit(value, 1)
    },
    formatCurrency(value) {
      if (!value) return '--'
      return utils.formatCurrency(value)
    },
    formatPercent(value) {
      if(!value) return '--'
      return `${utils.formatDigit(value)}%`
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.profit_box {
  position: relative;
  margin-bottom: 16px;
  padding: 10px;
  border: 1px solid $border;

  @media (min-width: 1380px) {
    display: flex;
    flex: auto;
    align-items: center;
  }

  &--sections {
    display: flex;
    flex-grow: 1;
    justify-content: space-between;
    align-items: stretch;
  }

  &--divider {
    border-left: 1px solid $border;
  }

  &--section {
    width: 30%;

    &--heading {
      margin-bottom: 8px;
      font-size: 14px;
      font-weight: bold;
      text-align: center;
      color: $text-muted;
    }

    &--stat:not(:last-child) {
      margin-right: 20px;
    }

    &--stat--label {
      margin-top: 8px;
      font-size: 0.75rem;
      text-align: center;

      &.positive {
        color: $success;
      }

      &.negative {
        color: $danger;
      }
    }

    &--stat--count {
      font-size: 25px;
      font-weight: bold;
      text-align: center;
    }
  }
}
</style>
